import React from 'react';
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';
import DownloadIcon from '@mui/icons-material/Download';
import ActionButton from '../../ui/primitives/ActionButton';

const PDF_PAGE_WIDTH_MM = 210;
const MARGIN_MM = 10;
const PX_PER_MM = 3.7795;

const DashboardExportPdfButton = ({
  targetRef,
  fileName = 'dashboard-insights',
  loading,
  setLoading,
  onBeforeExport,
  onAfterExport,
}) => {
  const handleExportPdf = async () => {
    if (!targetRef?.current) return;

    setLoading(true);
    try {
      if (onBeforeExport) {
        await onBeforeExport();
      }

      const canvas = await html2canvas(targetRef.current, {
        backgroundColor: '#fff',
        useCORS: true,
        scale: 2,
      });

      const imgData = canvas.toDataURL('image/png');
      const imgWidthMM = canvas.width / PX_PER_MM;
      const imgHeightMM = canvas.height / PX_PER_MM;
      const scaleFactor = (PDF_PAGE_WIDTH_MM - MARGIN_MM * 2) / imgWidthMM;
      const scaledWidthMM = imgWidthMM * scaleFactor;
      const scaledHeightMM = imgHeightMM * scaleFactor;

      const pdf = new jsPDF('p', 'mm');
      pdf.internal.pageSize.setWidth(PDF_PAGE_WIDTH_MM);
      pdf.internal.pageSize.setHeight(scaledHeightMM + MARGIN_MM * 2);
      pdf.addImage(imgData, 'PNG', MARGIN_MM, MARGIN_MM, scaledWidthMM, scaledHeightMM);
      pdf.save(`${fileName}.pdf`);
    } catch (error) {
      console.error('Dashboard Insights PDF export failed:', error);
    } finally {
      if (onAfterExport) {
        onAfterExport();
      }
      setLoading(false);
    }
  };

  return (
    <ActionButton
      label={loading ? 'Exporting...' : 'Export'}
      icon={<DownloadIcon />}
      intent="primary"
      onClick={handleExportPdf}
      disabled={loading}
      loading={loading}
    />
  );
};

export default DashboardExportPdfButton;